import React from 'react'
import styled from 'styled-components'

import TrendForm from 'pages/shared/TrendForm'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'
import { defaultTrend } from 'models/Trend'

const AddTrend = () => (
  <>
    <PageHeader>
      <S.PageTitle>Add Trend</S.PageTitle>
    </PageHeader>
    <S.SinglePanePage>
      <TrendForm
        saveMethod="create"
        trend={defaultTrend}
      />
    </S.SinglePanePage>
  </>
)

export default AddTrend

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
